import featureFlagsConstants from '../Constants/featureFlags.constants';

// Feature flag configuration - maps flags to allowed customer IDs
const FEATURE_FLAG_CONFIG = {
	CAN_ORDER_IN_PACKS: [70, 72, 5, 52, 54],
	CAN_SUB_PACKAGE_ORDER: [73],
};

/**
 * Computes feature flags based on customerId
 * @param {number} customerId - The customer ID from appConfig
 * @returns {Object} - Object containing computed feature flags
 */
export const computeFeatureFlags = (customerId) => {
	return {
		CAN_ORDER_IN_PACKS:
			FEATURE_FLAG_CONFIG.CAN_ORDER_IN_PACKS.includes(customerId),
		CAN_SUB_PACKAGE_ORDER:
			FEATURE_FLAG_CONFIG.CAN_SUB_PACKAGE_ORDER.includes(customerId),
	};
};

/**
 * Sets all feature flags at once
 * @param {Object} flags - Object containing feature flags
 */
export const setFeatureFlags = (flags) => ({
	type: featureFlagsConstants.SET_FEATURE_FLAGS,
	payload: flags,
});

/**
 * Updates a single feature flag
 * @param {string} flag - The feature flag name
 * @param {boolean} value - The feature flag value
 */
export const updateFeatureFlag = (flag, value) => ({
	type: featureFlagsConstants.UPDATE_FEATURE_FLAG,
	payload: {
		flag,
		value,
	},
});

/**
 * Initializes feature flags based on customerId
 * @param {number} customerId - The customer ID from appConfig
 */
export const initializeFeatureFlags = (customerId) => (dispatch) => {
	const flags = computeFeatureFlags(customerId);
	dispatch(setFeatureFlags(flags));
};
